var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonWeb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.33 93.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:#010101;}.cls-5,.cls-6,.cls-7{fill:#e9e8e8;}.cls-8{fill:#fff;}.cls-9{fill:#f38294;}.cls-10{fill:#daf0f7;}.cls-2,.cls-6{stroke-linecap:round;}.cls-2,.cls-6,.cls-11,.cls-3,.cls-12,.cls-4,.cls-7{stroke:#020202;stroke-width:2px;}.cls-11,.cls-12{fill:none;}.cls-3,.cls-12{stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 20.39,
    y: 0.2,
    width: 124.79,
    height: 92.91,
    transform: "translate(.15 -.26) rotate(.18)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.68,
    y: 29.79,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 25.68,
    y: 30.79,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 20.68,
    y: 24.79,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 21.68,
    y: 25.79,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 20.68,
    y: 24.79,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 21.68,
    y: 25.79,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.03,53.98l-14.44-11.58c-.43-.34-.83-.72-1.18-1.15-3.72-4.49-3.49-11.02,.3-14.93,3.53-3.63,9.47-4.31,14.09-1.39,4.66-3.23,10.36-3.73,14.12-1.04,4.23,3.03,5.72,8.81,3.53,13.66-.28,.62-.64,1.19-1.07,1.71-3.84,4.77-7.68,9.53-11.52,14.3-.94,1.17-2.66,1.35-3.83,.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M117.03,53.98l-14.44-11.58c-.43-.34-.83-.72-1.18-1.15-3.72-4.49-3.49-11.02,.3-14.93,3.53-3.63,9.47-4.31,14.09-1.39,4.66-3.23,10.36-3.73,14.12-1.04,4.23,3.03,5.72,8.81,3.53,13.66-.28,.62-.64,1.19-1.07,1.71-3.84,4.77-7.68,9.53-11.52,14.3-.94,1.17-2.66,1.35-3.83,.41h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M114.03,49.98l-14.44-11.58c-.43-.34-.83-.72-1.18-1.15-3.72-4.49-3.49-11.02,.3-14.93,3.53-3.63,9.47-4.31,14.09-1.39,4.66-3.23,10.36-3.73,14.12-1.04,4.23,3.03,5.72,8.81,3.53,13.66-.28,.62-.64,1.19-1.07,1.71-3.84,4.77-7.68,9.53-11.52,14.3-.94,1.17-2.66,1.35-3.83,.41h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M114.03,49.98l-14.44-11.58c-.43-.34-.83-.72-1.18-1.15-3.72-4.49-3.49-11.02,.3-14.93,3.53-3.63,9.47-4.31,14.09-1.39,4.66-3.23,10.36-3.73,14.12-1.04,4.23,3.03,5.72,8.81,3.53,13.66-.28,.62-.64,1.19-1.07,1.71-3.84,4.77-7.68,9.53-11.52,14.3-.94,1.17-2.66,1.35-3.83,.41h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33.68,76.98c0-33.5,45-34,45,0H33.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.68,76.98c0-33.5,45-34,45,0H33.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 56.18,
    cy: 34.98,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 56.18,
    cy: 34.98,
    r: 13.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.68,71.98c0-33.5,45-34,45,0H28.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.68,71.98c0-33.5,45-34,45,0H28.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 51.18,
    cy: 29.98,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 51.18,
    cy: 29.98,
    r: 13.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonWeb);
export default __webpack_public_path__ + "static/media/person_web.ae79afad1b335e69383a4484dab243a6.svg";
export { ForwardRef as ReactComponent };